import { cn } from "@paribus/shared-ui";
import React from "react";

export interface VisitsToolbarFilterGroupViewProps {
  icon: React.ReactNode;
  label: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

/**
 * Rounded shell: leading icon + label, then the control (typically {@link VisitsToolbarNativeSelect}).
 * The control flex-fills the remaining width so its value/chevron never clip.
 */
export const VisitsToolbarFilterGroupView: React.FC<VisitsToolbarFilterGroupViewProps> = ({
  icon,
  label,
  children,
  className,
}) => (
  <div
    className={cn(
      "flex h-10 min-w-0 items-center gap-2 rounded-xl border border-neutral-200/80 bg-neutral-50/50 pl-3 pr-1.5 transition-colors focus-within:shadow-focus-inset hover:bg-neutral-100/50",
      className
    )}
  >
    <div className="flex shrink-0 items-center gap-1.5 text-neutral-400">
      {icon}
      {label}
    </div>
    {children}
  </div>
);
